import { uploadToBucketCall } from 'redux-core/images/services';
import { getCommercialImportUploadAccessCall } from './services';

export const uploadCommercialImportFile = async (file: File): Promise<string> => {
  const contentType = file.type;
  // getCommercialImportUploadAccessCall's static return type is the untyped request layer's
  // AxiosResponse, which doesn't reflect the response interceptor's runtime data-unwrap — the
  // real resolved shape (asserted here) is { key, uploadUrl, kind }.
  const { key, uploadUrl } = (await getCommercialImportUploadAccessCall({
    kind: contentType,
    contentType,
  })) as unknown as {
    key: string;
    uploadUrl: string;
  };

  // Built as a variable (not an inline literal) since uploadToBucketCall's untyped JS
  // signature only declares `{ file }`, and TS's excess-property check on object literals
  // would otherwise reject the contentType key. contentType is kept here for signature
  // parity with the sibling's call shape, not because it does anything: uploadToBucketCall
  // (redux-core/images/services.js) destructures only `{ file }` and currently ignores it.
  const uploadPayload = { file, contentType };
  await uploadToBucketCall(uploadUrl, uploadPayload);
  return key;
};
